import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Grid,
    FormControl,
    InputLabel
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1,
        paddingLeft: '15px',
        marginBottom: '10px'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: '0 5px 0',
        minWidth: 120,
        width: '90%',
        display: "flex",
        wrap: "nowrap"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    }
});

function SearchComponent(props) {
    // let { classes, airlines, selectChange, AirlineId, FlightNumber, StartDate, EndDate, flightNumbers } = props;
    let { user, classes, StartDate, EndDate, airlines, airports,
        selectChange, onSearch, handleDateChange, AirportId } = props;
    return (
        <div className={classes.root}>
            <Grid container spacing={24}>
                <Grid item md={2}>
                    <FormControl
                        className={classes.formControl}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airlines
                        </InputLabel>
                        <AutocompleteSelect
                            options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            name={"AirlineId"}
                        />
                        {/*
                        <Select
                            value={AirlineId}
                            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="AirlineId"
                            className={classes.selectEmpty}
                        >
                            <MenuItem value="-1">All Airlines</MenuItem>
                            {airlines.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option.AirlineId}
                                    className={classes.select}
                                >
                                    {option.Airline}
                                </MenuItem>
                            ))}
                        </Select>
                        */}
                    </FormControl>
                </Grid>
                <Grid item md={2}>
                    <FormControl
                        className={classes.formControl}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airports
                        </InputLabel>
                        <AutocompleteSelect
                            options={airports.map(option => ({value: option.Code, label: option.Name}))}
                            name={"AirportId"}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                            selectedOption={AirportId}
                        />
                        {/*
                         <Select
                            value={AirportId}
                            disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="AirportId"
                            className={classes.selectEmpty}
                        >
                            <MenuItem value="-1">All Airports</MenuItem>
                            {airports.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option.Code}
                                    className={classes.select}
                                >
                                    {option.Name}
                                </MenuItem>
                            ))}
                        </Select>
                        */}
                    </FormControl>
                </Grid>
                <Grid item md={3}>
                    <div>
                        <InlineDatePicker label={'Start Date'} Date={StartDate}  handleDateChange={(date) => handleDateChange(date, 'StartDate')} />
                    </div>
                </Grid>
                <Grid item md={3}>
                    <div>
                        <InlineDatePicker label={'End Date'} Date={EndDate}  handleDateChange={(date) => handleDateChange(date, 'EndDate')} />
                    </div>
                </Grid>
                <Grid item md={2}>
                    <Button color={'primary'} onClick={()=>onSearch()}>Search</Button>
                </Grid>
            </Grid>
        </div>
    );
}

SearchComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    selectChange: PropTypes.func.isRequired
};

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/views/PSCUtilization/SearchPanel.jsx